import Script, { type ScriptProps } from 'next/script'

type ScriptClarityProps = ScriptProps & {
  projectId: string
}

export function ScriptClarity({ projectId, ...props }: ScriptClarityProps) {
  if (!projectId) {
    return <></>
  }

  const content = `
  (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${projectId}");`

  return (
    <Script id='ms_clarity' strategy='afterInteractive' {...props}>
      {content}
    </Script>
  )
}
